"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UiConfigSchema = exports.TaskSchema = void 0;
const zod_1 = require("zod");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
exports.TaskSchema = tape_sanitizer_1.JoinTransformationSchema.omit({
    srcDataTape: true,
    joinDataTape: true,
}).extend({
    operation: zod_1.z.literal('join'),
    srcArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Source (input) artifact slug for this operation'),
    joinArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Artifact slug of the tape to join against'),
});
exports.UiConfigSchema = exports.TaskSchema;
exports.nodeType = 'operation_join';
//# sourceMappingURL=types.js.map